module.exports = __webpack_public_path__ + "static/img/expert_768.43630b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/expert_768.png
// module id = SJTS
// module chunks = 0